import { render, staticRenderFns } from "./post-agree.vue?vue&type=template&id=d0d68f12&"
import script from "./post-agree.vue?vue&type=script&lang=js&"
export * from "./post-agree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports